import { isNil } from '@easytwin/runtime';

export function findItemInTreeList<T extends { children: T[] }>(
  treeList: T[] | T,
  predicate: (item: T) => boolean,
): T | undefined {
  if (Array.isArray(treeList)) {
    if (isNil(treeList) || treeList.length === 0) return;
    for (const i of treeList) {
      if (predicate(i)) {
        return i;
      }
      const res = findItemInTreeList(i.children, predicate);
      if (!isNil(res)) {
        return res;
      }
    }
    return undefined;
  }

  if (predicate(treeList)) {
    return treeList;
  } else {
    const res = findItemInTreeList(treeList.children, predicate);
    if (!isNil(res)) {
      return res;
    }
  }
}
